import BASE_URL from "components/BaseUrl/apiConfig";
import React, { useEffect, useState } from "react";

export default function ExpensesTypewisetable() {
  const [expensestData, setExpenseData] = useState([]);
  const [chartData, setChartData] = useState([]);
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear()); // Initialize with the current year
  const [currency, setCurrency] = useState("");
  const storedUserData = localStorage.getItem("userData");
  let userId = "";
  let groupId = "";

  if (storedUserData) {
    const userData = JSON.parse(storedUserData);
    userId = userData.userId;
    groupId = userData.groupId;
  }

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(
          `${BASE_URL}/api/Analytics/GetExpensesByTypewise?groupId=${groupId}&year=${selectedYear}`
        );
        const data = await response.json();
        setExpenseData(data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, [selectedYear]);

  useEffect(() => {
    const fetchCurrencyData = async () => {
      try {
        const response = await fetch(
          `${BASE_URL}/api/Users/GetCurrencyByUserId?groupId=${groupId}`
        );
        const data = await response.json();
        // Assuming the API response has a property called 'currency'
        setCurrency(data.currency);
        // console.log(data);
      } catch (error) {
        console.error("Error fetching currency data:", error);
      } finally {
      }
    };

    fetchCurrencyData();
  }, []); // The empty dependency array ensures that this effect runs only once when the component mounts

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(
          `${BASE_URL}/api/Analytics/GetYearlyExpenseChart?groupId=${groupId}&year=${selectedYear}`
        );
        const data = await response.json();
        setChartData(data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, [selectedYear]);

  const handleYearChange = (e) => {
    setSelectedYear(parseInt(e.target.value, 10));
  };

  const getMonthName = (monthNumber) => {
    const monthNames = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];
    return monthNames[monthNumber - 1];
  };

  const transposeData = (data) => {
    const transposedData = {};
    data.forEach((expense) => {
      if (!transposedData[expense.expenseDescType]) {
        transposedData[expense.expenseDescType] = {};
      }
      transposedData[expense.expenseDescType][expense.month] =
        expense.totalExpenses;
    });
    return transposedData;
  };

  const transposedExpenseData = transposeData(expensestData);

  return (
    <>
      <div className="relative flex flex-col min-w-0 break-words bg-white w-full shadow-lg !rounded">
        <div className="rounded mr-4 pl-4 mt-4 bg-transparent">
          <div className="flex flex-wrap items-center">
            <div className="relative w-full max-w-full flex-grow flex-1">
              <div className=" flex justify-between">
                <div>
                  <h2
                    className="text-blueGray-700 text-xl font-semibold"
                    style={{ fontSize: "1rem" }}
                  >
                    Category Wise Expenses({currency})
                  </h2>
                </div>
                <div className="mr-4">
                  <select
                    className="bg-white-800 text-black border border-white-600 rounded px-6 py-1 outline- ne focus:outline-none w-32"
                    value={selectedYear}
                    onChange={handleYearChange}
                  >
                    {/* Populate with years */}
                    <option value={new Date().getFullYear()}>
                      {new Date().getFullYear()}
                    </option>
                    <option value={new Date().getFullYear() - 1}>
                      {new Date().getFullYear() - 1}
                    </option>
                    {/* Add more years as needed */}
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="p-4 flex-auto">
          <div className="relative h-auto">
            <div className="relative overflow-x-auto">
              <table className="w-full min-w-full border border-gray-300">
                <thead>
                  <tr className="border-b bg-lightBlue-500 text-white">
                    <th
                      className=" border-b  dark:bg-gray-800"
                      style={{ paddingLeft: "5px" }}
                    >
                      Expense Type
                    </th>
                    {Array.from({ length: 12 }, (_, i) => i + 1).map(
                      (monthNumber) => (
                        <th key={monthNumber} style={{ paddingLeft: "5px" }}>
                          {getMonthName(monthNumber)}
                        </th>
                      )
                    )}
                    <th style={{ paddingLeft: "5px" }}>Total</th>{" "}
                    {/* Add new column for total */}
                  </tr>
                </thead>
                <tbody>
                  {Object.keys(transposedExpenseData).map((expenseType) => {
                    // Calculate total expenses for the current expense type
                    const totalExpense = Array.from(
                      { length: 12 },
                      (_, i) => i + 1
                    ).reduce(
                      (acc, monthNumber) =>
                        acc +
                        (transposedExpenseData[expenseType][monthNumber] || 0),
                      0
                    );

                    // Check if totalExpense is not zero, if it is then skip rendering this row
                    if (totalExpense !== 0) {
                      return (
                        <tr
                          key={expenseType}
                          className="border border-gray-300"
                        >
                          <td
                            style={{ paddingLeft: "5px" }}
                            title={expenseType.length > 18 ? expenseType : null}
                          >
                            {expenseType.length > 18
                              ? `${expenseType.substring(0, 15)}...`
                              : expenseType}
                          </td>

                          {/* Render expense data for each month */}
                          {Array.from({ length: 12 }, (_, i) => i + 1).map(
                            (monthNumber) => (
                              <td
                                key={monthNumber}
                                style={{ paddingLeft: "5px" }}
                              >
                                {transposedExpenseData[expenseType][
                                  monthNumber
                                ] || ""}
                              </td>
                            )
                          )}

                          {/* Render total expense for the expense type */}
                          <td
                            style={{
                              backgroundColor: "paleturquoise",
                              paddingLeft: "5px",
                            }}
                          >
                            {totalExpense}
                          </td>
                        </tr>
                      );
                    } else {
                      return null; // Skip rendering this row
                    }
                  })}

                  {/* New row for totalDebit and totalCredit */}
                  <tr>
                    <td style={{ paddingLeft: "5px" }}>Total Debited</td>
                    {chartData.map((dataItem, index) => (
                      <td
                        key={index}
                        style={{
                          backgroundColor:
                            "rgba(249, 115, 22, var(--tw-text-opacity))",
                          paddingLeft: "5px",
                        }}
                      >
                        {dataItem.totalDebit || ""}
                      </td>
                    ))}
                    <td
                      style={{
                        paddingLeft: "5px",
                        backgroundColor:
                          "rgba(249, 115, 22, var(--tw-text-opacity))",
                        fontWeight: "bold",
                      }}
                    >
                      {/* Calculate the sum of totalDebit */}
                      {chartData.reduce(
                        (total, dataItem) =>
                          total + (parseFloat(dataItem.totalDebit) || 0),
                        0
                      )}
                    </td>
                  </tr>

                  <tr>
                    <td style={{ paddingLeft: "5px" }}>Total Credited</td>
                    {chartData.map((dataItem, index) => (
                      <td
                        key={index}
                        style={{
                          backgroundColor:
                            "rgba(16, 185, 129, var(--tw-text-opacity))",
                          paddingLeft: "5px",
                        }}
                      >
                        {dataItem.totalCredit || ""}
                      </td>
                    ))}
                    <td
                      style={{
                        paddingLeft: "5px",
                        backgroundColor:
                          "rgba(16, 185, 129, var(--tw-text-opacity))",
                        fontWeight: "bold",
                      }}
                    >
                      {/* Calculate the sum of totalDebit */}
                      {chartData.reduce(
                        (total, dataItem) =>
                          total + (parseFloat(dataItem.totalCredit) || 0),
                        0
                      )}
                    </td>
                  </tr>
                </tbody>
                <style>
                  {`
                            table, td, th {
                                border: 1px solid #ddd;
                                text-align: left;
                            }

                            table {
                                border-collapse: collapse;
                                width: 100%;
                            }
                        `}
                </style>
              </table>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
